import { CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { getPageTypeFromPathname } from "../../helpers/helpers";
import { EventData, EventPayload } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ScrollytellingSlideViewedPayload extends EventPayload {
  message: {
    title: string;
    body: string;
  };
}

const ScrollytellingSlideViewedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: getPageTypeFromPathname(),
  eventName: "Content Page Scrollytelling Block Slide Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createScrollytellingSlideViewedTrackEventPayload = () => {
  return eventPagePayloadCreator<ScrollytellingSlideViewedPayload>(
    ScrollytellingSlideViewedAnalyticsEvent,
  );
};
